<template>
  <div class="home">
    <div
      class="banner"
      :style="`background-image:url(${state.homebanner})`"
    ></div>
    <!-- http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/home_head_picture@3x.svg -->
    <!-- http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/siggraph logo-03 (2).svg -->
    <div class="shadow"></div>
    <div class="address animate__animated animate__backInUp">
      <img
        src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/home_head_picture@3x.svg"
        alt=""
      />
    </div>
    <div class="association" :class="{ wow: true, wo: true }">
      <div>
        {{
          (locale == "zh" && state.associationlist?.title) ||
          state.associationlist?.en_title
        }}
      </div>
      <div>
        {{
          (locale == "zh" && state.associationlist?.content) ||
          state.associationlist?.en_content
        }}
      </div>
    </div>
  </div>
  <!-- {{ state.upcoming_activity.full_background_image }} -->
  <div
    v-if="state.upcoming_activity"
    class="activity"
    :style="`background-image:url(${state.upcoming_activity?.full_background_image})`"
  >
    <div class="shadow"></div>
    <div class="atitle">{{ $t("header.Upcoming_events") }}</div>
    <div
      class="adetail"
      :class="{ wow: true, wo: state.d1 }"
      style="transition: all 2s"
    >
      <div @click="topath('/activity?id=' + state.upcoming_activity?.id)">
        {{
          (locale == "zh" && state.upcoming_activity?.title) ||
          state.upcoming_activity?.en_title || state.upcoming_activity?.title
        }}
      </div>
      <div class="aimage">
        <img :src="state.upcoming_activity?.full_image" alt="" />
      </div>
      <div>
        {{ state.upcoming_activity?.created_at?.slice(0, 10) }}
      </div>
    </div>
  </div>

  <div
    class="newinformation"
    :class="{ wow: true, wo: state.d1 }"
    style="transition: all 3.25s"
  >
    <div class="one">{{ $t("header.Picture_at_a_glance") }}</div>

    <div class="more" @click="topath('/Picture')">
      {{ $t("header.see_more") }}
    </div>
  </div>

  <div class="carousel-container" :class="{ wow: true, wo: state.d2 }">
    <el-carousel
      ref="swipertwoRefs"
      :interval="2000"
      arrow="never"
      type="card"
      height="400px"
    >
      <el-carousel-item v-for="(item, index) in state.activity" :key="index">
        <!-- <video :src="item.video" v-if="item.video"></video> -->
        <img v-if="item" :src="item.pictrue" style="width: 100%" alt="" />
        <div
          class="name"
          style="
            margin-top: 40px;
            color: #d6d7c8;
            text-align: center;
            font-size: 22px;
            font-weight: 800;
          "
        >
          {{ item.cooperative_project_name }}
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>

  <!-- <div class="swiper">
    <div class="activityinformation">
      <div class="custom-swiper">
        <div
          class="swiper-wrapper"
          :style="{ transform: `translateX(${state.translateX}px)` }"
        >
          <div
            class="swiper-slide"
            v-for="(slide, index) in state.activity"
            :key="index"
            :class="{ wow: true, wo: state.d2 }"
            :style="getdog(index)"
          >
            <div>{{ (locale == "zh" && slide.title) || slide.en_title }}</div>
            <div>
              {{ (locale == "zh" && slide.intro) || slide.en_intro }}
            </div>
            <div>{{ slide.created_at?.slice(0, 10) }}</div>
            <div class="readmore" @click="topath('/activity?id=' + slide.id)">
              <div>{{ $t("header.get_info") }}</div>
              <div>
                <img
                  src="https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/joi(2).svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prev-button" @click="prevSlide">
      <img
        src="https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/home_icon_arrow.svg"
        alt=""
      />
    </div>
    <div class="next-button" @click="nextSlide">
      <img
        src="https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/home_icon_arrow.svg"
        alt=""
      />
    </div>
  </div> -->

  <div
    class="newinformation"
    :class="{ wow: true, wo: state.d2 }"
    style="transition: all 3.25s"
  >
    <div class="one">{{ $t("header.latest_news") }}</div>
    <div class="more" @click="topath('/information')">
      {{ $t("header.see_more") }}
    </div>
  </div>
  <div class="informationcontent">
    <informations
      :ani="state.d3"
      :informationlist="state.newlist"
    ></informations>
  </div>
</template>

<script setup>
import { reactive, onMounted } from "vue";
import informations from "@/components/informations.vue";
import { useRouter } from "vue-router";
import { gethome } from "@/api/type";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const { data } = gethome().then((res) => {
  // console.log("====================================");
  // console.log(res, 987654321);
  // console.log("====================================");
  state.associationlist = res.data.aboutus.brief_introduction[0];
  state.homebanner = res.data.banner.full_img;
  state.newlist = res.data.news;
  // 即将举行的活动数据
  state.upcoming_activity = res.data.latest_activity;
  // 最新活动的数据
  state.activity = res.data.picture_overviwes;
  // console.log(state.activity, 987987);
});

const router = useRouter();
const handleScroll = () => {
  const scrollY = window.scrollY || window.pageYOffset;
  // console.log(scrollY, 989898);
  if (scrollY > 300) {
    state.d1 = true;
  }
  if (scrollY > 900) {
    state.d2 = true;
  }
  if (scrollY > 1600) {
    state.d3 = true;
  }
};
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});
const topath = (e) => {
  router.push(e);
};
const getdog = (e) => {
  if (e == 0) {
    return "transition: all 1.5s;";
  }
  if (e == 1) {
    return "transition: all 2s;";
  }
  if (e == 2) {
    return "transition: all 2.5s;";
  }
};
const prevSlide = () => {
  if (state.currentIndex > 0) {
    state.currentIndex--;
    updateSlider();
  }
};
const nextSlide = () => {
  if (state.currentIndex < state.slides.length - 1) {
    state.currentIndex++;
    updateSlider();
  }
};
const updateSlider = () => {
  state.translateX = -state.currentIndex * 392; // 每个幻灯片宽度为100%
};
const state = reactive({
  associationlist: [],
  upcoming_activity: [],
  activity: [],
  homebanner: "",
  newlist: [],
  d1: false,
  d2: false,
  d3: false,
  currentIndex: 0,
  translateX: 0,
  slides: ["Slide 1", "Slide 2", "Slide 3", "Slide 1", "Slide 2", "Slide 3"], //你的轮播内容
  // formationlist: [
  //   {
  //     img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
  //     title: "2023 年行业聚迟行业聚焦推迟",
  //     detail:
  //       "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
  //     data: "2023.09.13",
  //     id: 1,
  //   },
  //   {
  //     img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
  //     title: "2023 年行业聚焦推迟",
  //     detail:
  //       "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
  //     data: "2023.09.13",
  //     id: 2,
  //   },
  //   {
  //     img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
  //     title: "2023 年行业聚焦推迟行业聚焦推迟行业聚焦推迟",
  //     detail:
  //       "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
  //     data: "2023.09.13",
  //     id: 3,
  //   },
  //   {
  //     img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
  //     title: "2023 年行业聚焦推迟",
  //     detail:
  //       "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
  //     data: "2023.09.13",
  //     id: 4,
  //   },
  // ],
});
</script>
<style lang="scss" scoped>
@import "@/sass/index.scss";
.home {
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  .banner {
    position: absolute;
    top: -100px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    height: 100vh;
    background-image: url("https://bunseninstitutes.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center; /* 将背景图像始终定位在容器的中心 */
  }
  .shadow {
    position: absolute;
    top: -100px;
    left: 0;
    width: 100%;
    height: 100vh;
    // z-index: 1;
    background-color: rgba($color: #000000, $alpha: 0.6);
  }
  .address {
    position: absolute;
    z-index: auto;
    // : 50%;
    bottom: 213px;
    // transform: translate(-50%, 0%) !important;
    // @at-roottransform : translate3d(-50%, 100%, 0);
    // transform: translate3d(0%, 50%, 0);
    animation-duration: 1s;
    animation-delay: 0.1s;
    animation-name: identifier;
  }
  .association {
    box-sizing: border-box;
    max-width: 1176px;
    padding: 60px 100px;
    animation-duration: 1s;
    animation-delay: 0.1s;
    animation-name: identifier;
    // margin: 0 auto;
    text-align: left;
    position: absolute;
    background-color: #fff;
    bottom: 3px;
    // top: -217px;
    :nth-child(1) {
      @include fontstyle(#333, 24px, 800, auto);
      line-height: 28px;
      margin-bottom: 16px;
    }
    :nth-child(2) {
      @include fontstyle(#333, 16px, 400, auto);
      line-height: 26px;
    }
  }
}
.swiper {
  position: relative;
  max-width: 1177px;
  margin: 0 auto 80px;
  .prev-button {
    position: absolute;
    left: -80px;
    top: calc(50% - 10px);
    cursor: pointer;
    transition: all 0.2s;
    transform: rotate(180deg);
    &:hover {
      filter: invert(100%);
    }
  }
  .next-button {
    position: absolute;
    right: -80px;
    // right: 0;
    top: calc(50% - 10px);
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      filter: invert(100%);
    }
  }
}
.activityinformation {
  max-width: 1177px;
  margin: 0 auto 80px;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;

  .swiper-wrapper {
    display: flex;
    width: 100%;
    overflow: hidden;
    transition: all 0.5s;
    // max-width: 1176px;
    &:first-child {
      border-left: 2px solid #999;
    }
    .swiper-slide {
      box-sizing: border-box;
      width: 392px;
      padding: 20px 36px 20px;
      text-align: left;
      border-right: 2px solid #999;
      line-height: 26px;
      :nth-child(1) {
        @include fontstyle(#333, 22px, 800, auto);
        margin-bottom: 24px;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 限制显示的行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal; /* 防止文字溢出隐藏 */
        text-overflow: ellipsis;
      }
      :nth-child(2) {
        @include fontstyle(#333, 16px, 400, auto);
        margin-bottom: 4px;
        display: -webkit-box;
        -webkit-line-clamp: 4; /* 限制显示的行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal; /* 防止文字溢出隐藏 */
        text-overflow: ellipsis;
        white-space: pre-line;
      }
      :nth-child(3) {
        @include fontstyle(#333, 16px, 400, auto);
        margin-bottom: 24px;
      }
      :nth-child(4) {
        @include fontstyle(#333, 16px, 400, auto);
        margin-bottom: 36px;
      }
      .readmore {
        display: flex;
        align-items: center;
        position: relative;
        &:hover {
          :nth-child(2) {
            left: 78px;
            opacity: 1;
          }
        }
        :nth-child(1) {
          // display: inline-block;
          @include fontstyle(#4a53d7, 16px, 800, pointer);
          margin-bottom: 0px;
          transition: all 0.5s;
          width: 72px;
          &::after {
            content: "";
            display: block;
            position: absolute;
            width: 64px;
            height: 2px;
            background: #4a53d7;
            top: 10px;
            opacity: 0;
            transition: all 0.5s;
          }
          &:hover {
            // border-bottom: 2px solid #4a53d7;
            &::after {
              content: "";
              top: 24px;
              opacity: 1;
            }
          }
        }
        :nth-child(2) {
          position: absolute;
          transition: all 0.5s;
          margin-bottom: 0px;
          left: 0px;
          opacity: 0;
          img {
            width: auto !important;
          }
        }
      }
      :nth-child(5) {
      }
    }
  }
}

.newinformation {
  display: flex;
  box-sizing: border-box;
  max-width: 1176px;
  margin: 0 auto;
  justify-content: center;
  position: relative;
  // top: -197px;
  :nth-child(1) {
    align-self: center;
    text-align: center;
    display: inline-block;
    @include fontstyle(#333, 40px, 800, auto);
    line-height: 47px;
    margin-bottom: 48px;
    border-bottom: 8px solid #f4775e;
    padding-bottom: 3px;
  }
  :nth-child(2) {
    position: absolute;
    right: 0px;
    top: 20px;
    @include fontstyle(#333, 14px, 400, pointer);
    &:hover {
      text-decoration: underline;
    }
  }
}
.informationcontent {
  position: relative;
  // top: -197px;
}
.carousel-container {
  box-sizing: border-box;
  max-width: 1176px;
  margin: 0 auto 65px;
}
.activity {
  box-sizing: border-box;
  max-width: 1176px;
  margin: 0 auto;
  background: #999999;
  display: flex;
  height: 374px;
  margin-bottom: 130px;
  margin-top: 40px;
  // visibility: hidden;
  padding: 0 100px;
  position: relative;
  background-image: url("https://bunseninstitutes.oss-cn-hangzhou.aliyuncs.com/files/images/SA2020-Virtual-768x768%20(1).jpg");
  align-items: center;
  clip: rect(0, auto, auto, 0);
  --fill-layer-background-media-position: fixed;
  background-size: cover;
  background-attachment: fixed;
  .shadow {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(46, 49, 48, 0.8);
  }
  .atitle {
    @include fontstyle(#fff, 24px, 800, auto);
    display: flex;
    z-index: 1;
    align-items: center;
    &::after {
      content: "";
      display: block;
      width: 124px;
      height: 4px;
      background: #fff;
      margin-left: 10px;
    }
  }
  .adetail {
    position: absolute;
    box-sizing: border-box;
    width: 424px;
    right: 176px;
    padding: 60px 36px;
    background: #3f58de;
    text-align: left;
    line-height: 26px;
    :nth-child(1) {
      @include fontstyle(#fff, 22px, 800, auto);
      cursor: pointer;
      margin-bottom: 32px;
      &:hover {
        text-decoration: underline;
      }
    }
    :nth-child(3) {
      @include fontstyle(#fff, 16, 400, auto);
      opacity: 0.5;
    }
    .aimage {
      img {
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .swiper {
    .prev-button {
      left: 10px;
      // bottom: 0;
    }
    .next-button {
      right: 10px;
    }
  }
  .informationcontent {
    padding: 0 30px;
  }
  .activity {
    margin: 0 30px 100px 30px;
    .adetail {
    }
  }
}
@media screen and (max-width: 1080px) {
  .activity {
    display: flex;
    flex-direction: column;
    height: 600px;
    padding: 30px 30px;
    .atitle {
      margin-bottom: 30px;
    }
    .adetail {
      position: initial;
    }
  }
}
@media screen and (max-width: 800px) {
  .i_content {
    .message {
      .mationdetail {
        width: 95%;
      }
    }
  }
  .swiper {
    .activityinformation {
      .swiper-wrapper {
        &:first-child {
          border-left: 0px !important;
        }
        .swiper-slide {
          border-right: 0px !important;
          padding: 20px 54px 20px !important;
        }
      }
    }
  }
  .home {
    .address {
      width: 100%;
      padding: 0 0px;
      bottom: 318px;
      img {
        max-width: 100%;
      }
    }
  }
  .association {
    padding: 60px 30px !important;
  }
  .newinformation {
    .more {
      margin-right: 30px;
    }
  }
  .activity {
    .adetail {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.el-carousel__indicators {
  display: none;
}
@media screen and (max-width: 1000px) {
  .el-carousel .el-carousel__container {
    height: 220px !important;
  }
  .carousel-container {
    margin: 0 30px !important;
  }
}
</style>
